var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.290039 20.9552V2.52243C0.289948 2.21407 0.371219 1.91114 0.525648 1.64424C0.680077 1.37734 0.902195 1.15591 1.16957 1.00231C1.43695 0.848706 1.74013 0.768372 2.04849 0.769419C2.35684 0.770466 2.65946 0.852855 2.92579 1.00827L18.7246 10.2264C18.9889 10.3808 19.2082 10.6018 19.3606 10.8673C19.513 11.1328 19.5932 11.4336 19.5932 11.7397C19.5932 12.0458 19.513 12.3466 19.3606 12.6121C19.2082 12.8776 18.9889 13.0986 18.7246 13.253L2.92579 22.4694C2.65946 22.6248 2.35684 22.7072 2.04849 22.7082C1.74013 22.7092 1.43695 22.6289 1.16957 22.4753C0.902195 22.3217 0.680077 22.1003 0.525648 21.8334C0.371219 21.5665 0.289948 21.2636 0.290039 20.9552Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.077f38e3969d49220979d95d7a5c75bb.svg";
export { ForwardRef as ReactComponent };